/**
=========================================================
* BASE: Learning Repository - v1.0.0
=========================================================

* Copyright 2022 Sean Dooley (https://www.dooley-dev.com)

Coded by www.dooley-dev.com

 =========================================================

* The above copyright notice shall be included in substantial portions of the Software.
*/
// React
import React from "react";
// form library
import { Controller, useFormContext } from 'react-hook-form';
// base components
import BASELoading from "../../../../../@BASE/core/BASELoading";
// material ui components
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
// custom components
import LeadNumberedHeading from "../../../../shared-components/forms/LeadNumberedHeading";
import TemplateSelect from "./selects/TemplateSelect";

function TemplateTab(props) {
  const methods = useFormContext();
  const { control, formState } = methods;
  const { errors } = formState;

  const { templates, template, handleTemplateChange } = props;

  // if the templates are loading, show a loading spinner
  if (!templates || !Array.isArray(templates) || templates.length === 0) {
    return <BASELoading />;
  }

  return (
    <div>
      <LeadNumberedHeading number="2" title="Template" instructions="Select a template for the page." />

      <Typography variant="subtitle1" className="mb-16 font-semibold">
        Template:
      </Typography>

      <Controller
        name="template"
        control={control}
        render={({ field }) => <TemplateSelect className="mt-16" templates={templates} handleTemplateChange={handleTemplateChange} errors={errors} {...field} />}
      />

      {!template ? (
        <div className="flex flex-1 items-center justify-center min-h-320">
          <Typography color="text.secondary">
            Please select a template to continue...
          </Typography>
        </div>
      ) : (
        <div className="mt-32">
          <Typography variant="subtitle1" className="mb-16 font-semibold">
            General Information
          </Typography>

          <Divider className="mt-16" />

          <Accordion
            className="bg-transparent shadow-none border-b-1 border-t-0"
            sx={{
              [`&:before`]: {
                display: 'none'
              },
            }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
              className="px-0 border-0"
            >
              <Typography variant="subtitle1" className="font-semibold">
                Activity Rationale:
              </Typography>
            </AccordionSummary>
            <AccordionDetails
              className="px-0"
            >
              <Typography variant="body2" className="pb-16">
                {template.description}
              </Typography>
            </AccordionDetails>
          </Accordion>

          <Accordion
            className="bg-transparent shadow-none border-b-1 border-t-0"
            sx={{
              [`&:before`]: {
                display: 'none'
              },
            }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
              className="px-0"
            >
              <Typography variant="subtitle1" className="font-semibold">
                Instructions:
              </Typography>
            </AccordionSummary>
            <AccordionDetails
              className="px-0"
            >
              {template.instructions && (
                <List>
                  {template.instructions.map((item, index) => (
                    <ListItem key={index} className="px-0 border-t-1">
                      <ListItemText
                        primary={
                          <Typography variant="subtitle2" className="font-semibold">
                            {item.title}
                          </Typography>
                        }
                        secondary={
                          <Typography variant="body2">
                            {item.content}
                          </Typography>
                        }
                      />
                    </ListItem>
                  ))}
                </List>
              )}
            </AccordionDetails>
          </Accordion>          
        </div>
      )}
    </div>
  );
}

export default TemplateTab;